import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { PageSectionWrapper } from 'src/domains/players/webview/components/SignUp/signupParts/Signup.style';
import { Message } from './ClosureModeSignup.style';

export const ClosureModeSignup = observer('ClosureModeSignup', () => {
    return (
        <PageSectionWrapper>
            <Message>
                <I18n
                    langKey='signup.closure.not-active'
                    defaultText='Signup is not active'
                />
            </Message>
        </PageSectionWrapper>
    );
});
